import React from 'react'
import Stars from './Stars'
import MotivationBars from './MotivationBars'

export default function Motivation ({stars, byItem, assessmentSubtests}) {
  return (
    <div className="skill-box motivation ">
      <div className="skill-information ">
        <h1 className="skill-name ">Motivation</h1>
        <Stars stars={stars} />
        <p className="skill-description ">
          This rating shows the likelihood that your students were motivated 
          to perform as well as possible on the test. The graphic
				  shows the percentage of correct answers in each test segment.
        </p>
      </div>
      <MotivationBars byItem={byItem} assessmentSubtests={assessmentSubtests} />
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/TestTaking/Motivation.js